<template>
    <div>
        <form
            :action="url"
            method="POST"
            ref="formRef"
        >
            <BrandedCard
                @click="formRef?.submit()"
                class="cursor-pointer"
            >
                <div class="flex items-center gap-4">
                    <div class="min-w-14">
                        <Image
                            class="h-14 w-14 mx-auto object-cover rounded-full"
                            :src="
                                companyUserAggregate.user.getProfilePictureUrlWithFallback()
                            "
                        />
                    </div>
                    <div class="font-medium">
                        {{ companyUserAggregate.user.getFullName() }}
                    </div>
                </div>
                <div
                    class="flex justify-end items-center gap-1 text-sm text-gray-600"
                >
                    <span> Select </span>
                    <Icon
                        name="arrow-right"
                        class="w-3 h-3 text-gray-500"
                    />
                </div>
            </BrandedCard>
        </form>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import BrandedCard from '@/BookingForm/BookingForm/Component/BrandedCard.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import Image from '@/Shared/Component/Image.vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        companySlug: {
            type: String,
            required: true,
        },
        serviceSlug: {
            type: String,
            required: true,
        },
        companyUserAggregate: {
            type: Object as PropType<CompanyUserAggregate>,
            required: true,
        },
        draftMeetingId: {
            type: Number,
            required: true,
        },
        localizer: {
            type: Object as PropType<LocalizerService>,
            required: true,
        },
    })

    const formRef = ref<ApiFormRefType>(null)

    const url = new UrlFactory().makeBookingFormCompanyUserSelectionUrl(
        props.companySlug,
        props.serviceSlug,
        props.draftMeetingId,
        props.companyUserAggregate.companyUser.id,
        props.localizer.getLocale(),
    )
</script>
